<template>
	<div>
	    <table class="tabs">
	        <th class="flex-1" v-for="(tab, index) in tabs" v-bind:class="tab.isActive?'active':'not-active'">
	        	<!-- <div class="pos-rel align-hor"> -->
		            <div class="padding-10" @click="selectTab(tab)">{{ getTranslatedText(tab.name) }}</div>
		            <!-- <div v-show="index>0" class="pos-abs" style="width:1px;height: 100%;background: white"></div>
		        </div> -->
	        </th>
	    </table>

	    <div class="tabs-details">
	        <slot></slot>
	    </div>
	</div>
</template>
<script>
	import { globals } from "@/mixins/globals"
	export default {
		mixins: [globals],
		data() {
	        return {tabs: [] };
	    },
	    
	    created() {
	        this.tabs = this.$children;
	    },
	    methods: {
	        selectTab(selectedTab) {
	            this.tabs.forEach(tab => {
	                tab.isActive = (tab.name == selectedTab.name);
	            });
	        }
	    }
	}
</script>
<style>
	.tabs {
		color: white;
		display: flex;
		background: #58A30B;
	}

	.tabs th.active{
		background: #11550a;
	}

</style>


// WEBPACK FOOTER //
// src/components/tabs.vue